import { cn } from '@/lib/utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  /** Maximum width variant. Defaults to 'default' (1360px) */
  maxWidth?: 'default' | 'full' | 'narrow';
}

const maxWidthStyles = {
  default: 'max-w-[1360px]',
  full: 'max-w-full',
  narrow: 'max-w-4xl',
};

export function Container({ children, className, maxWidth = 'default' }: ContainerProps) {
  return (
    <div className={cn(
      'mx-auto px-4 sm:px-6 lg:px-8',
      maxWidthStyles[maxWidth],
      className
    )}>
      {children}
    </div>
  );
}
